import React from "react";
import "./NameContainer.css";

function NameContainer(){
    return(
        
        <div className="nameContainer">
                <h1 className="kirubel">Kirubel Eshetu</h1>
                <h2 className="fresh">Fresh Graduate</h2>
            </div>
    )
};

export default NameContainer;
 